export interface CustodyAccountVerificationResponse {
	verification_status: CustodyAccountVerificationStatus;
}

export enum CustodyAccountVerificationStatus {
	VERIFIED = "VERIFIED",
	NOT_VERIFIED = "NOT_VERIFIED",
	VERIFICATION_IN_PROGRESS = "VERIFICATION_IN_PROGRESS",
	NOT_VERIFIED_FINAL = "NOT_VERIFIED_FINAL"
}
